import { Query } from '@apollo/client/react/components';
import { useQuery, useLazyQuery } from '@apollo/client';
import { AccountClient, GET_ASSET_LIST, RMMClient } from '@nile/graphql';
import {
  GET_ROLES,
  GET_USER_ROLE_TYPES
} from '@nile/banyan/src/Graphql/Mutations/role';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/banyan/src/Pebbles/select';
import {
  reactSelectErrorStyles,
  reactSelectInlineError
} from '@nile/banyan/src/Utils/style';
import {
  HeaderTag,
  preFormatForm,
  trimInputValues,
  userConstraints,
  validateForm,
  AccessControl,
  ApiProgressLoader,
  COLOR_MAP,
  Loader,
  getTranslatedText,
  TEXT_LENGTH,
  PHONE_NUMBER_LENGTH,
  getDifference
} from '@nile/components/src';
import {
  CHECK_USER_EMAIL,
  GET_CLIENT_USER,
  GET_CLIENT_USERS
} from '@nile/graphql/src/Query/client';
import {
  SecondaryButton,
  isAuthorised,
  CardContent,
  noRestrictionToPlans
} from '@nile/components';
import { isEmpty, pick, random } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import {
  Banner,
  Spinner,
  TextField as PhonenumberInput,
  Page,
  Button,
  ButtonGroup,
  Checkbox,
  TextStyle,
  DisplayText,
  Avatar,
  Heading,
  Card,
  TextField,
  Label,
  Link,
  SkeletonBodyText
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  emailValidator,
  plaintextValidator
} from '@nile/components/src/Validators/fields';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import AssetTypeCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-type-cell';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import InviteUserButton from '@nile/client_management/src/Components/InviteUserButton';
import UserCustomFieldList from '@nile/banyan/src/Pages/Protected/Configuration/UserCustomFields';
import MultiClientSelector from '@nile/client_management/src/Components/MultiClientSelector';
// import AllClientTickets from '@nile/client_management/src/Containers/ClientDetails/AllClientTickets';
import AllRequesterTickets from '@nile/client_management/src/Containers/Requester/AllRequesterTickets';
import { isFeatureAvailable } from '@nile/components/src/HOC/withPlanFeatureGating';
import { GET_ALL_ASSETS } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { getParsedCrudDataForClientAssociations } from '@nile/client_management/src/Utils/helpers';

const EmailBannerContainer = styled.div`
  position: absolute;
  left: 52%;
  display: grid;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
`;

const NewWrapper = styled.div`
  .phone-number {
    text-decoration: none;
  }
  .Ticket-Tabs .Polaris-Tabs__Tab {
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
    color: black;
    font-weight: 500;
    padding-left: 0px;
    padding-right: 0px;
    opacity: 0.7;
  }
  .Ticket-Tabs .Polaris-Tabs__Tab--selected {
    color: black;
    opacity: 1;
  }
  .react-bell-chat__bubble-group {
    margin: 0 !important;
  }
  .pageAct {
    flex-grow: 1;
    justify-content: center;
  }

  .actionsWrapper {
    height: 117px;
    border-bottom: 1px solid #ececec;
    display: flex;
  }

  .TabPage {
    justify-content: center;
    overflow: auto;
    height: calc(100% - 150px);
    background: #f2f2f7;
  }

  .section-0 {
    min-width: 50%;
    max-width: 50%;
  }
  .section-1 {
    min-width: 50%;
    max-width: 50%;
    overflow: hidden;

    .Polaris-Card,
    .Superops-Page {
      box-shadow: unset;
    }
    .Polaris-Card,
    .Superops-Card {
      padding: 0px 40px;
      max-height: 250px;
      overflow: auto;
    }
  }

  .scheduled-ticket {
    padding-left: 30px;
    position: relative;
    .schedule-icon {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .ticket-source-svg {
    width: 14px;
    height: 14px;
  }
`;

const ReuesterFormWrapper = styled.div.attrs({
  className: 'fw scroll'
})`
  flex: 1;
  .req-heading {
    z-index: 21;
    padding: 20px 40px;
    border-bottom: 1px solid var(--sops-divider);
    box-shadow: 0px 2px 3px var(--sops-scroll-shadow);
  }
  .req-form {
    padding: 20px 40px;
  }
`;

const AssetsListWrapper = styled.div`
  .module-logo {
    height: 25px !important;
    width: 25px !important;
    min-height: 25px;
    min-width: 25px;
    margin-right: 8px;
  }
  .hide {
    display: none;
    .Superops-Button {
      min-height: 25px !important;
      min-width: 30px !important;
      height: 25px;
      width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .Superops-Button__Content {
      font-size: 12px !important;
    }
  }
  &:hover {
    .hide {
      display: block;
    }
  }

  .disabled-remote-options {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .disabled-remote-options > div {
    pointer-events: none;
  }
`;

const Sections = styled.div`
  max-height: calc(100% - 100px);
  min-height: calc(100% - 180px);
`;

const Section = styled.div`
  flex-grow: 1;
  border-right: 1px solid #ececec;
  max-width: 60%;
  height: 100%;
  &.full-width {
    max-width: 100%;
  }
  &.no-border {
    border-right: unset;
    &.section-1 {
      min-width: 100%;
      max-width: 100%;
    }
  }
`;

function DetailsPageLayout(props) {
  return (
    <div className="white details-page full-height flex col">
      <div className="details-header border-thin pd-y0 ">{props.header}</div>
      <Sections
        className={`flex fg1 details-content ${props.sections.length < 2 &&
          'fx jctr'}`}
      >
        {props.sections
          ? props.sections.map((section, idx) => {
              return (
                <Section
                  className={`${section.className} ${props.sections.length <
                    2 && 'no-border'}`}
                >
                  {section.component}
                </Section>
              );
            })
          : ''}
      </Sections>
    </div>
  );
}

function AssociateAssets(props) {
  const { requester } = props;
  const tabContext = useContext(TicketContext);
  const [assetsList, setAssetsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchAllAssets, { loading, data, error }] = useLazyQuery(
    GET_ALL_ASSETS,
    {
      client: RMMClient,
      fetchPolicy: 'network-only',
      onCompleted: ({ getAllAssets }) => {
        setAssetsList((prev) => [...prev, ...getAllAssets?.assets]);
        setCurrentPage((prevPage) => prevPage + 1);
      }
    }
  );

  const getQueryVariables = (page) => ({
    viewType: 'ALL_MONITORED_ASSET',
    listInfo: {
      page,
      pageSize: 5,
      sort: [
        {
          attribute: 'name',
          order: 'ASC'
        }
      ],
      condition: {
        joinOperator: 'AND',
        operands: [
          {
            attribute: 'owner.userId',
            operator: 'is',
            value: requester.userId
          }
        ]
      }
    }
  });

  useEffect(() => {
    if (requester.userId) {
      fetchAllAssets({
        variables: getQueryVariables(1)
      });
    }
  }, [requester.userId]);

  const handleLoadMore = () => {
    fetchAllAssets({
      variables: getQueryVariables(currentPage)
    });
  };

  // if (loading && currentPage === 1) return <div>loading...</div>;
  if (error) return <div>error...</div>;
  return (
    <div>
      {loading && currentPage === 1 ? (
        <SkeletonBodyText lines={3} />
      ) : (
        <>
          <AssetsListWrapper>
            {assetsList?.length > 0 ? (
              assetsList.map((el) => (
                <div
                  key={el.assetId}
                  className="flex asset line-height-35 center"
                >
                  <AssetTypeCell cell={{ row: { original: el } }} />
                  <div
                    className="ml8 ellipsis font-weight-500 cursor-pointer"
                    onClick={() => {
                      props?.globalTabContext
                        ? props?.globalTabContext({
                            module: 'ASSET_DETAILS',
                            data: {
                              id: el.assetId,
                              classId: el?.assetClass?.classId,
                              subject: el?.name
                            }
                          })
                        : tabContext?.openTab({
                            module: 'ASSET_DETAILS',
                            data: {
                              id: el.assetId,
                              classId: el?.assetClass?.classId,
                              subject: el?.name
                            }
                          });
                    }}
                  >
                    {el.name}
                  </div>
                  {/* <AccessControl
        roleToCheck="tickets.edit"
        render={
          <div className="mlauto hide">
            <Button
              id="psaAssociateAssets"
              onClick={associateAssets.bind(this, el)}
            >
              <div className="ellipsis">Associate</div>
            </Button>
          </div>
        }
      /> */}
                </div>
              ))
            ) : (
              <div className="mt10">
                <FormattedMessage id="ticket.details.insights.assets.noAssets" />
              </div>
            )}
          </AssetsListWrapper>

          {loading && currentPage > 1 && <SkeletonBodyText lines={3} />}

          {!loading && data?.getAllAssets?.listInfo?.hasMore && (
            <div className="mt-10">
              <Link onClick={handleLoadMore}>
                <FormattedMessage id="admin.billing.invoices.viewmore" />
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
}

class UserForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: props.user ? props.user.userId : '',
      firstName: props.user ? props.user.firstName : '',
      lastName: props.user ? props.user.lastName : '',
      email: props.user ? props.user.email : '',
      phoneNumber: props.user ? props.user.phoneNumber : '',
      contactNumber: props.user?.contactNumber
        ? props.user.contactNumber
        : `${props.user?.countryCode || ''}${props.user?.phoneNumber || ''}`,
      countryCode: props.user ? props.user.countryCode : '',
      phoneCountryCode: '',
      formattedValue: '',
      isTouched: false,
      designation: props.user?.designation
        ? props.user.designation
        : { name: '' },
      businessFunction: props.user?.businessFunction
        ? props.user.businessFunction
        : { name: '' },
      team: props.user?.team ? props.user.team : { name: '' },
      associatedRole: props.user ? props.user.associatedRole : '',
      site: props.user ? props?.user?.site : '',
      associations: props?.user?.associations || [],
      clientList: props?.user?.associations || [],
      associatedGroup: {
        associated: []
      },
      customFields: props.user?.customFields ? props.user.customFields : {},
      reportingManager: props?.user?.reportingManager || {},
      role: props?.user?.role || {},
      errors: {},
      submitActionLoading: false,
      sendActivationMail: true,
      tabContext: props?.tabContext,
      appContext: props?.appContext,
      isTicketAuthorised: isAuthorised(
        props?.appContext?.user?.role?.roleFeatureList || [],
        'tickets.view'
      ),
      splashtopWFHEnabled: props?.user?.splashtopWFHEnabled,
      remoteDesktopAddOnEnabledStatus:
        props?.user?.remoteDesktopAddOnEnabledStatus
    };
  }

  containsError = (key) => {
    const { errors } = this.state;
    return errors && errors[key] && errors[key][0];
  };

  constructDropDownStyles = (key) => {
    return this.containsError(key)
      ? {
          ...{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          },
          ...reactSelectErrorStyles
        }
      : {
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 })
        };
  };

  constructDropDownError = (key) => {
    const { errors } = this.state;
    if (this.containsError(key)) {
      if (key === 'clientList') {
        return reactSelectInlineError(
          getTranslatedText(
            this.props.intl,
            'client.details.clientSite.empty.message'
          )
        );
      }
      return reactSelectInlineError(errors[key][0]);
    }
    return null;
  };

  handleSubmit() {
    const {
      firstName,
      lastName,
      email,
      sendActivationMail,
      phoneNumber,
      contactNumber,
      countryCode = '',
      phoneCountryCode,
      formattedValue,
      isTouched,
      reportingManager,
      role,
      site,
      customFields,
      associations
    } = this.state;
    // const { accountId } = this.props;

    const { tabContext, ...dummyForm } = this.state;
    let validationResult = validateForm(
      preFormatForm(dummyForm),
      userConstraints
    );
    let phoneError;

    const primarySiteExists = this.state.clientList.every((currEl) => {
      const primarySiteId =
        this.state.clientList.find(
          (el) =>
            el.client?.accountId === currEl?.client?.accountId && el.primarySite
        )?.site?.id || null;
      return !!primarySiteId;
    });

    //  =
    //   !isTouched || isValidPhoneNumber(formattedValue, phoneCountryCode)
    //     ? true
    //     : 'Invalid phone number';
    // Not mandatory check
    // if (isTouched && phoneNumber.length === 0) {
    //   phoneError = true;
    // }
    // if (phoneError !== true) {
    //   if (!validationResult) {
    //     validationResult = {};
    //   }
    //   validationResult['phoneNumber'] = phoneError;
    // } else {
    //   delete validationResult?.phoneNumber;
    // }
    if (validationResult || !primarySiteExists) {
      this.setState({
        errors: {
          ...validationResult,
          primarySiteError: !primarySiteExists
        }
      });
      return;
    }

    // let clientList = [];
    // this.state.clientList.map((item) => {
    //   if (!isEmpty(item?.client) && !isEmpty(item?.site)) {
    //     clientList.push(item);
    //   }
    // });
    // update the client list id if the site is present in the associations list

    let result = getParsedCrudDataForClientAssociations(
      this.state.associations,
      this.state.clientList,
      'site.id'
    );
    const resultAssociations = {
      addAssociations: result?.addedItems.map((item) => ({
        client: {
          accountId: item.client.accountId
        },
        site: {
          id: item.site.id
        },
        primarySite: item.primarySite
      })),
      updateAssociations: result?.updatedItems.map((item) => ({
        id: item.id,
        client: {
          accountId: item.client.accountId
        },
        site: {
          id: item.site.id
        },
        primarySite: item.primarySite
      })),
      deleteAssociations: result?.deletedItems.map((item) => ({
        id: item.id
      }))
    };
    this.setState({ submitActionLoading: true });
    this.setState({ errors: {} });

    let designation =
      this.state.designation && this.state.designation.designationId
        ? {
            designationId: this.state.designation.designationId,
            name: this.state.designation.name
          }
        : { name: this.state.designation.name };
    let businessFunction =
      this.state.businessFunction &&
      this.state.businessFunction.businessFunctionId
        ? {
            businessFunctionId: this.state.businessFunction.businessFunctionId,
            name: this.state.businessFunction.name
          }
        : { name: this.state.businessFunction.name };
    let team =
      this.state.team && this.state.team.teamId
        ? { teamId: this.state.team.teamId, name: this.state.team.name }
        : { name: this.state.team.name };
    if (this.props.user) {
      const { userId } = this.props.user;
      let inputParams = {};
      if (designation && designation.name)
        inputParams.designation = designation;
      if (businessFunction && businessFunction.name)
        inputParams.businessFunction = businessFunction;
      if (team && team.name) inputParams.team = team;
      inputParams.reportingManager = reportingManager?.userId
        ? reportingManager
        : null;
      if (role && role.roleId) inputParams.role = role;
      let updatedCustomFields;
      if (customFields) {
        updatedCustomFields = getDifference(
          customFields,
          this.props.user.customFields
        );
      }
      let trimmedForm = {
        userId,
        firstName,
        lastName,
        email,
        phoneNumber,
        contactNumber,
        countryCode,
        ...inputParams
      };
      this.props?.updateRequesterData(trimmedForm);
      if (updatedCustomFields) {
        trimmedForm.customFields = updatedCustomFields;
      }
      trimmedForm = trimInputValues(trimmedForm);
      this.props.actions.primaryAction({
        variables: {
          site: site,
          ...resultAssociations,
          ...trimmedForm
        },
        input: {
          site: site,
          ...resultAssociations,
          ...trimmedForm
        }
      });
    } else {
      const {
        firstName,
        lastName,
        email,
        phoneNumber,
        contactNumber,
        countryCode = '',
        designation,
        businessFunction,
        customFields,
        team
      } = this.state;
      let inputParams = {};
      if (designation && designation.name)
        inputParams.designation = designation;
      if (businessFunction && businessFunction.name)
        inputParams.businessFunction = businessFunction;
      if (team && team.name) inputParams.team = team;
      inputParams.reportingManager = reportingManager?.userId
        ? reportingManager
        : null;
      if (role && role.roleId) inputParams.role = role;
      let trimmedForm = {
        firstName,
        lastName,
        email,
        sendActivationMail,
        phoneNumber,
        contactNumber,
        countryCode,
        site,
        customFields,
        ...inputParams
      };
      trimmedForm = trimInputValues(trimmedForm);
      this.props.actions
        .primaryAction({
          variables: {
            ...trimmedForm,
            ...resultAssociations
          },
          input: {
            ...trimmedForm,
            ...resultAssociations
          }
        })
        .then((res) => {
          this.setState({ submitActionLoading: false });
        });
    }
  }

  handleChange = (field) => {
    return (value) => this.setState({ [field]: value });
  };
  checkIfClientNull = () => {
    if (!isEmpty(this.state.clientList)) {
      let clientError = validateForm(
        {
          clientList: this.state.clientList
        },
        {
          clientList: {
            array: {
              'client.accountId': plaintextValidator({ mandatory: true })
            }
          }
        }
      );
      if (clientError) {
        this.setState({ errors: { clientList: clientError } });
        return true;
      }
    }
    return false;
  };

  checkIfRequesterExists = () => {
    if (!isEmpty(this.state.email)) {
      let emailError = validateForm(
        { email: this.state.email },
        { email: emailValidator({ mandatory: true }) }
      );

      //in edit mode check if email changed
      let shouldCheckEmail = !(
        this.props?.user?.email && this.props?.user?.email === this.state.email
      );

      if (!emailError && shouldCheckEmail) {
        this.timer && clearTimeout(this.timer);
        this.setState({ errors: { email: null } });
        this.setState({ userData: 'loading' });

        //api call to check if requester exist using email id
        AccountClient.mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            email: this.state.email,
            accountType: 'CLIENT',
            validateDomain: false
          }
        }).then(({ data }) => {
          this.setState({
            userData: data?.checkUserEmailAddressAvailability
          });
        });
      } else {
        this.setState({ errors: emailError });
      }
    }
  };

  getDisplayMessage = (data) => {
    switch (data.status) {
      case 'DUPLICATE_EMAIL_ADDRESS':
        return (
          <Banner status="info">
            <h5>
              {getTranslatedText(
                this.props.intl,
                'client.details.user.message.alreadyExist'
              )}
              {/* <Link onClick={this.fillExistingUserData}>
                <FormattedMessage id="app.btn.show" />
              </Link> */}
            </h5>
          </Banner>
        );
      case 'AVAILABLE':
        return <ApiProgressLoader isSuccess />;
      case 'DUPLICATE_EMAIL_ADDRESS_IN_DIFFERENT_ACCOUNT_TYPE':
        return (
          <Banner status="info">
            <h5>
              {getTranslatedText(
                this.props.intl,
                'client.details.user.message.alreadyExist.with.differentAccountType'
              )}
            </h5>
          </Banner>
        );
      case 'DUPLICATE_EMAIL_ADDRESS_AS_MAILBOX_ADDRESS':
        return (
          <Banner status="info">
            <h5>
              {getTranslatedText(
                this.props.intl,
                'app.error.duplicate.email.address.as.mailbox.address'
              )}
            </h5>
          </Banner>
        );
      default:
        return (
          <Banner status="info">
            <h5>{data.status}</h5>
          </Banner>
        );
    }
  };

  fillExistingUserData = () => {
    //api call to get existing user data and fill form
    AccountClient.query({
      query: GET_CLIENT_USER,
      variables: {
        userId: this.state.userData.userId,
        userCustomFields: false
      },
      fetchPolicy: 'network-only'
    }).then(({ data }) => {
      this.props?.actions?.switchToEdit(data?.getClientUser, 'edit');
    });
  };

  handleSelectChange = (fieldName, newValue) => {
    let obj = {};
    if (newValue) {
      obj.name = newValue.label;
      obj[fieldName + 'Id'] = newValue[fieldName + 'Id'];
      this.setState({ [fieldName]: obj, errors: {} });
    } else {
      this.setState({ [fieldName]: '', errors: {} });
    }
  };

  handleSiteChange = (fieldName, newValue) => {
    let obj = pick(newValue, ['id', 'name']);
    this.setState({ [fieldName]: obj, errors: {} });
  };

  updateClientList = (ClientList) => {
    this.setState({ clientList: ClientList, errors: {} });
  };

  handleUserInformation = (field, value) => {
    if (field === 'reportingManager') {
      let val = pick(value, ['userId', 'firstName', 'lastName', 'email']);
      this.setState({ [field]: val, errors: {} });
    } else if (field === 'role') {
      let val = pick(value, ['roleId', 'name']);
      this.setState({ [field]: val, errors: {} });
    }
  };

  handlePhoneNumberInput = (value) => {
    this.setState({
      contactNumber: value.trim(),
      phoneNumber: value.trim(),
      isTouched: true
    });
  };

  render() {
    const { intl, isMSP, flags } = this.props;
    const AssetModuleNameBackend = 'WINDOWS_MANAGEMENT';
    const TicketFeatureNameBackend = 'TICKETING';

    const showSendActivationMail = !this.props.user;
    let {
      firstName,
      lastName,
      email,
      sendActivationMail,
      phoneNumber,
      countryCode,
      phoneCountryCode,
      contactNumber,
      team,
      designation,
      businessFunction,
      errors,
      customFields,
      submitActionLoading,
      clientList,
      tabContext,
      appContext,
      isTicketAuthorised,
      splashtopWFHEnabled,
      remoteDesktopAddOnEnabledStatus
    } = this.state;
    let accountId = null;
    if (this.props.accountId) {
      accountId = this.props.accountId;
    }
    if (
      this.state?.clientList?.[0] &&
      this.state?.clientList?.[0]?.client?.accountId
    ) {
      accountId = this.state?.clientList?.[0]?.client?.accountId;
    }
    const isAssetManagementAvailable = isFeatureAvailable(
      appContext?.planFeatureList,
      AssetModuleNameBackend
    );

    const isTicketsAvailable = isFeatureAvailable(
      appContext?.planFeatureList,
      TicketFeatureNameBackend
    );
    const sections = [
      {
        id: 'details',
        className: 'section-1 flex fcol wrap bg-white full-height',
        component: (
          <>
            {isAssetManagementAvailable &&
              appContext?.accountType !== 'CLIENT' && (
                <Card customClassName="full-width g15">
                  <CardContent
                    header={
                      <Heading element="h3" weight="bold">
                        <FormattedMessage id="ticket.details.insights.requesterassets" />
                      </Heading>
                    }
                    content={
                      <AssociateAssets
                        requester={this.state}
                        globalTabContext={this.props?.globalTabContext}
                      />
                    }
                    classNames="bg-white pt16 pb10 position-sticky"
                  />
                </Card>
              )}
            <ReuesterFormWrapper>
              <div className="fx req-heading position-sticky bg-white actr fx-sb">
                <Heading element="h3" weight="bold">
                  <FormattedMessage id="client.details.h2.userinfo" />
                </Heading>
                <ButtonGroup>
                  {/* <Button
                      plain
                      onClick={() => {
                        this.props.actions.back();
                      }}
                      plainSecondary
                    >
                      <FormattedMessage id="app.action.cancel" />
                    </Button> */}
                  <SecondaryButton
                    loading={submitActionLoading}
                    onClick={this.handleSubmit.bind(this)}
                  />
                </ButtonGroup>
              </div>
              <div className="req-form">
                {/* <div
                  className={`flex mb10 ${this.props.newLayout ? '' : ''}`}
                >
                  <HeaderTag
                    title={getTranslatedText(
                      intl,
                      'client.details.h2.userprofile'
                    )}
                    isBgStrip
                    isNewLayout={this.props.newLayout}
                    type={this.props.newLayout ? '16px' : undefined}
                  />
                </div> */}
                <div className="w50  user-form">
                  <TextField
                    value={firstName}
                    id="userFirstname"
                    onChange={this.handleChange('firstName')}
                    label={getTranslatedText(
                      intl,
                      'client.details.user.firstname'
                    )}
                    placeholder={getTranslatedText(
                      intl,
                      'client.requester.firstName.placeholder'
                    )}
                    name="firstName"
                    type="text"
                    error={errors?.firstName?.[0]}
                    maxLength={TEXT_LENGTH.size_4}
                  />
                  <TextField
                    label={getTranslatedText(
                      intl,
                      'client.details.user.lastname'
                    )}
                    id="userLastname"
                    value={lastName}
                    onChange={this.handleChange('lastName')}
                    placeholder={getTranslatedText(
                      intl,
                      'client.requester.lastName.placeholder'
                    )}
                    name="lastName"
                    type="text"
                    error={errors?.lastName?.[0]}
                    maxLength={TEXT_LENGTH.size_4}
                  />
                </div>
                <div className="mb-30">
                  <div className="position-relative full-width">
                    <div className="w50">
                      <TextField
                        label={getTranslatedText(
                          intl,
                          'client.details.user.email'
                        )}
                        id="userEmail"
                        value={email}
                        onChange={this.handleChange('email')}
                        onBlur={this.checkIfRequesterExists}
                        placeholder={getTranslatedText(
                          intl,
                          'client.requester.email.placeholder'
                        )}
                        name="email"
                        type="text"
                        error={errors?.email?.[0]}
                        maxLength={TEXT_LENGTH.size_5}
                      />
                    </div>
                    <EmailBannerContainer>
                      {this.state.userData &&
                        (this.state.userData === 'loading' ? (
                          <Spinner size="small" />
                        ) : (
                          this.getDisplayMessage(this.state.userData)
                        ))}
                    </EmailBannerContainer>
                  </div>
                  {showSendActivationMail && (
                    <Checkbox
                      checked={sendActivationMail}
                      onChange={this.handleChange('sendActivationMail')}
                      label="Send Invite"
                    />
                  )}
                  {this.props?.user && this.props.user?.activated ? null : (
                    <InviteUserButton
                      linkType
                      showError
                      user={this.props.user}
                      onSuccess={this.props?.actions?.refreshTable}
                    />
                  )}
                </div>
                <div className="w50  user-form">
                  <div>
                    <Label>
                      {getTranslatedText(intl, 'client.details.user.phNo')}
                    </Label>
                    <PhonenumberInput
                      value={contactNumber || ''}
                      onChange={this.handlePhoneNumberInput}
                      maxLength={PHONE_NUMBER_LENGTH}
                      placeholder={getTranslatedText(
                        intl,
                        'client.requester.phonenumber.placeholder'
                      )}
                    />
                  </div>
                </div>

                <div className="">
                  <MultiClientSelector
                    responsive={true}
                    accountId={this.props.accountId}
                    clientList={this.state.clientList}
                    updateClientList={this.updateClientList}
                    clientsToFilter={this.state.clientList.map(
                      (data) => !isEmpty(data.client) && data.client
                    )}
                    actionType={this.props?.actions?.actionType}
                    enableMultiSelectSites={true}
                    errors={errors}
                    checkIfClientNull={this.checkIfClientNull}
                  />
                </div>

                <div className={`flex ${this.props.newLayout ? '' : ''}`}>
                  <HeaderTag
                    title={getTranslatedText(
                      intl,
                      'client.details.user.accessControl'
                    )}
                    isBgStrip
                    isNewLayout={this.props.newLayout}
                    type={this.props.newLayout ? '16px' : undefined}
                  />
                </div>
                <div className="w50">
                  <AccessControl
                    roleToCheck={isMSP ? 'role.view' : 'requesterRole.view'}
                    render={
                      <Query query={GET_USER_ROLE_TYPES} client={AccountClient}>
                        {({ loading, error, data: roles }) => {
                          if (loading) {
                            return <Loader />;
                          }
                          if (error) {
                            return <div>error</div>;
                          }

                          let rolesData = roles?.getUserRoleTypeRoles.map(
                            (el) => {
                              return {
                                ...el,
                                name: el.name,
                                value: el.name,
                                label: el.name
                              };
                            }
                          );

                          for (var i = 0; i < rolesData.length; i++) {
                            // rolesData[i].label = rolesData[i].name;
                          }

                          return (
                            <div className="mb-20">
                              <div className="Polaris-Labelled__LabelWrapper">
                                <div className="Polaris-Label">
                                  <label
                                    id="userPhoneLabel"
                                    for="userPhone"
                                    className="Polaris-Label__Text"
                                  >
                                    <FormattedMessage id="client.details.user.associateRole" />
                                  </label>
                                </div>
                              </div>
                              <Select
                                isClearable
                                // styles={colourStyles}
                                name="team"
                                value={rolesData.find(
                                  (el) => el.roleId === this.state.role?.roleId
                                )}
                                onChange={this.handleUserInformation.bind(
                                  this,
                                  'role'
                                )}
                                options={rolesData}
                                components={{
                                  IndicatorSeparator,
                                  DropdownIndicator
                                }}
                                classNamePrefix="value_selector"
                                formatGroupLabel={formatGroupLabel}
                                menuPlacement="auto"
                                menuPortalTarget={document.body}
                                placeholder={getTranslatedText(
                                  intl,
                                  'client.details.user.chooseRole'
                                )}
                                closeMenuOnScroll={(e) => {
                                  return (
                                    e.target &&
                                    e.target.classList &&
                                    !(
                                      e.target.classList.value.indexOf(
                                        'menu-list'
                                      ) > -1
                                    )
                                  );
                                }}
                                styles={this.constructDropDownStyles(
                                  'role.roleId'
                                )}
                              />
                              {this.constructDropDownError('role.roleId')}
                            </div>
                          );
                        }}
                      </Query>
                    }
                  />
                  {accountId && (
                    <Query
                      query={GET_CLIENT_USERS}
                      client={AccountClient}
                      variables={{
                        input: { clientId: accountId }
                      }}
                    >
                      {({ loading, error, data: users }) => {
                        if (loading) {
                          return <Loader />;
                        }
                        if (error) {
                          return <div>error</div>;
                        }

                        let userData = JSON.parse(
                          JSON.stringify(
                            users?.getClientUserAssociationsList?.associations
                          )
                        );
                        userData = userData.map((el) => {
                          el = el.user;
                          return {
                            ...el,
                            value: `${el.firstName} ${el.lastName}`,
                            label: `${el.firstName} ${el.lastName}`
                          };
                        });

                        return (
                          <div className="">
                            <div className="Polaris-Labelled__LabelWrapper">
                              <div className="Polaris-Label">
                                <label
                                  id="userPhoneLabel"
                                  for="userPhone"
                                  className="Polaris-Label__Text"
                                >
                                  <FormattedMessage id="client.details.user.reporting" />
                                </label>
                              </div>
                            </div>
                            {/* <Select
                      placeholder="Choose reporting manager"
                      label="Associate role"
                      onChange={this.handleEmployeeInformation}
                      options={rolesData} /> */}
                            <Select
                              isClearable
                              name="team"
                              value={userData.find(
                                (el) =>
                                  el.userId ===
                                  this.state.reportingManager?.userId
                              )}
                              onChange={this.handleUserInformation.bind(
                                this,
                                'reportingManager'
                              )}
                              options={userData}
                              components={{
                                IndicatorSeparator,
                                DropdownIndicator
                              }}
                              classNamePrefix="value_selector"
                              formatGroupLabel={formatGroupLabel}
                              menuPlacement="top"
                              placeholder={getTranslatedText(
                                intl,
                                'client.details.user.chooseUser'
                              )}
                              closeMenuOnScroll={(e) => {
                                return (
                                  e.target &&
                                  e.target.classList &&
                                  !(
                                    e.target.classList.value.indexOf(
                                      'menu-list'
                                    ) > -1
                                  )
                                );
                              }}
                              styles={this.constructDropDownStyles(
                                'reportingManager'
                              )}
                            />
                            {this.constructDropDownError('reportingManager')}
                          </div>
                        );
                      }}
                    </Query>
                  )}
                  <div className="flex col mt40 fw">
                    <UserCustomFieldList
                      userCustomFields={customFields}
                      updateUser={this.handleChange('customFields')}
                      intl={intl}
                      user={this.props.user}
                    />
                  </div>
                </div>
              </div>
            </ReuesterFormWrapper>
          </>
        )
      }
    ];
    isTicketsAvailable &&
      isTicketAuthorised &&
      sections.unshift({
        id: 'requester-tickets',
        className: 'section-0',
        component: (
          <AllRequesterTickets
            requester={this.state}
            globalTabContext={this.props?.globalTabContext}
          />
        )
      });
    return (
      <>
        <NewWrapper className="full-height pt10">
          <DetailsPageLayout
            header={
              <div className="flex full-height full-width bg-white p2040">
                <div className="flex mr30 center">
                  <Avatar initials={`${!!firstName ? firstName[0] : ''}`} />
                </div>
                <div className="fx fw fcol fg1">
                  <div className="flex mr10 fw mb16">
                    <DisplayText element="h1" weight="bold">
                      {firstName || ''} {lastName || ''}
                    </DisplayText>
                  </div>
                  <div className="flex g20">
                    {clientList[0]?.client?.name && (
                      <div className="fx center">
                        <div className="fx center mr4">
                          <SVGIcon name="ClientLogo" />
                        </div>
                        <TextStyle variation="strong">
                          {' '}
                          {clientList[0]?.client?.name}
                        </TextStyle>
                      </div>
                    )}
                    {clientList[0]?.site?.name && (
                      <div className="fx center">
                        <div className="fx center mr4">
                          <SVGIcon name="Site" />
                        </div>
                        <TextStyle variation="strong">
                          {' '}
                          {clientList[0]?.site?.name}
                        </TextStyle>
                      </div>
                    )}
                    {email && (
                      <div className="fx center">
                        <div className="fx center mr4">
                          <SVGIcon name="MailSettings" />
                        </div>
                        <TextStyle variation="strong">{email}</TextStyle>
                      </div>
                    )}
                    {!!phoneNumber && (
                      <div className="fx center">
                        <div className="fx center mr4">
                          <SVGIcon name="PhoneCall" />
                        </div>
                        <a className="phone-number" href={`tel:${phoneNumber}`}>
                          <TextStyle variation="strong">
                            {phoneNumber}
                          </TextStyle>
                        </a>
                      </div>
                    )}
                    {remoteDesktopAddOnEnabledStatus.ISL_ONLINE_WORK_FROM_HOME && (
                      <div className="flex actr g5">
                        <div className="flex">
                          <SVGIcon name="Isl" size="xl" />
                        </div>
                        <FormattedMessage id="Work From Home" />
                      </div>
                    )}
                    {remoteDesktopAddOnEnabledStatus.SPLASHTOP_WORK_FROM_HOME && (
                      <div className="flex actr g5">
                        <div className="flex">
                          <SVGIcon name="Splashtop" />
                        </div>
                        <FormattedMessage id="Work From Home" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
            sections={sections}
          />
        </NewWrapper>
      </>
    );
  }
}

export default withLDConsumer()(injectIntl(UserForm));
